import { IBlogResponse } from '@sapientpro/sapientpro-data-models';
import classNames from 'classnames';
import { useAtomValue } from 'jotai';
import styles from './BlogHead.module.scss';
import AnimatedTitle from '../../../components/AnimatedTitle';
import BannerArticle from './BannerArticle';
import { blogSearch } from '../../../store/blogFilters';
import BlogSearch from './BlogSearch';

const BlogHead = ({ data }: { data: IBlogResponse }) => {
  const search = useAtomValue(blogSearch);
  const isSearching = !!search;

  return (
    <section className={classNames(styles.headSection, 'container')}>
      <h1 className={styles.title}>
        <AnimatedTitle title='Our **Blog**' />
      </h1>
      <BlogSearch popularSearched={data.popularSearch} />

      {!isSearching && <BannerArticle post={data.banner} />}
    </section>
  );
};

export default BlogHead;
